import { useEffect } from 'react';

import { useGoogleApi } from './GoogleProvider';
import useInjectScript from './useInjectScript';

const DRIVE_SCOPE = 'https://www.googleapis.com/auth/drive.file';

export const useGoogleDrive = ({
  onSelectFiles,
  onPickerLoaded,
  onCancel,
  onGetToken,
}) => {
  const { loaded, clientId, apiKey } = useGoogleApi();
  const [apiLoaded] = useInjectScript('https://apis.google.com/js/api.js');

  const getAccessToken = (options) => {
    return new Promise((resolve, reject) => {
      const client = window.google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope: `openid profile email ${DRIVE_SCOPE}`,
        callback: (tokenResponse) => {
          if (tokenResponse.error) {
            reject(new Error(tokenResponse.error_subtype));
          } else {
            resolve(tokenResponse.access_token);
          }
        },
        error_callback: (e) => {
          reject(e);
        },
      });

      client.requestAccessToken(options);
    });
  };
  const createPicker = async ({ callbackFunction }) => {
    let token = await getAccessToken({
      prompt: '',
    });

    const view = new window.google.picker.DocsView(
      window.gapi.picker.api.ViewId.SPREADSHEETS
    );
    const picker = new window.google.picker.PickerBuilder()
      .setOAuthToken(token)
      .setDeveloperKey(apiKey)
      .setCallback((r) => {
        callbackFunction(r, token);
      })
      .addView(view)
      .build();

    picker.setVisible(true);
  };

  useEffect(() => {
    if (loaded && apiLoaded) {
      window.gapi.load('picker');
    }
  }, [loaded, apiLoaded]);

  return {
    onImport: (rowData) => async () => {
      createPicker({
        callbackFunction: ({ action, docs }, token) => {
          if (action === 'picked' && docs) {
            onSelectFiles?.({ ...rowData, docs, token });
          } else if (action === 'loaded') {
            onPickerLoaded?.(rowData);
          } else if (action === 'cancel') {
            onCancel?.(rowData);
          }
        },
      });
    },
    onExport: (rowData) => async () => {
      let token = await getAccessToken({
        prompt: '',
      });
      onGetToken({ ...rowData, token });
    },
  };
};
